module.exports = __webpack_public_path__ + "media/images/icon__close--rb-white-a399c51c1a465ecbf74a54ed5e192d0c.png";